const appName = 'xspace-bss';
const msgMap = {};
if (window.g_resource && window.g_resource[appName] && window.g_resource[appName].messages) {
  const messages = window.g_resource[appName].messages;
  for (const k in messages) {
    msgMap[`xspace.client.${k}`] = messages[k];
  }
}
export default function (prefix, key, params) {
  let resultMsg = msgMap[`xspace.client.${appName}.${prefix}.${key}`];
  if (params && resultMsg && resultMsg.indexOf('{') > -1) {
    for (const k in params) {
      resultMsg = resultMsg.replace(`{${k}}`, params[k]);
    }
  }
  if (!resultMsg) {
    return key;
  }
  return resultMsg;
}



// WEBPACK FOOTER //
// ./src/i18n/index.js